import React from "react";
import Tag from "../../../componentLibrary/Tag";

export default function TagComponents() {
  return (
    <>
      <h2 className="underline">Tag</h2>

      <div className="space-y-6">
        <div>
          <h3 className="text-lg font-medium text-gray-900 mb-3">Variants</h3>
          <div className="mb-4 p-4 bg-gray-50 rounded-lg">
            <h4 className="text-sm font-medium text-gray-900 mb-2">Usage:</h4>
            <p className="text-sm text-gray-700">
              Inline read-only label for displaying short values — e.g. a
              profile answer, a status, or a category. Use <code>variant</code>{" "}
              to communicate semantic meaning.
            </p>
          </div>
          <div className="flex flex-wrap gap-2">
            <Tag variant="default">Default</Tag>
            <Tag variant="success">Success</Tag>
            <Tag variant="warning">Warning</Tag>
            <Tag variant="danger">Danger</Tag>
            <Tag variant="neutral">Neutral</Tag>
          </div>
        </div>
      </div>
    </>
  );
}
